export const PURCHASE_TYPE = {
  DP: '0',
  CV: '1',
  OTHERS: '0,1' 
};

export const LS_USER = "MDSCVPORTAL_user";